module.exports = __webpack_public_path__ + "static/public-logo-c7284458cab46ce503fe713812478424.jpeg";